import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partner-info',
  templateUrl: './partner-info.component.html',
  styleUrls: ['./partner-info.component.css']
})
export class PartnerInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
